export class WeekViewUserModeProjectEntryModel {
    constructor() {
        this.projectName = "";
        this.projectNameDisplayAsString = "";
        this.projectCode = 0;
    }
}
export default class WeekViewUserModeProjectEntry extends WeekViewUserModeProjectEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
